import { render, staticRenderFns } from "./AS_ConsumerRegistration.vue?vue&type=template&id=77ba49a8&scoped=true&"
import script from "./AS_ConsumerRegistration.vue?vue&type=script&lang=js&"
export * from "./AS_ConsumerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AS_ConsumerRegistration.vue?vue&type=style&index=0&id=77ba49a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba49a8",
  null
  
)

export default component.exports